module.exports = __webpack_public_path__ + "static/media/galerija_2022_0013.413517e6.jpg";